import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import StylesProvider from '@mui/styles/StylesProvider';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { rootTheme } from 'theme/rootTheme';

export const muiRootTheme = createTheme(rootTheme);

export const ThemeProviders = ({ children }: { children: React.ReactNode }): React.ReactElement => {
  // Do all app level theme-ing here
  // MuiThemeProvider makes the theme available down the React tree
  // thanks to React context.
  return (
    <StylesProvider injectFirst>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={muiRootTheme}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
            <CssBaseline />
            {children}{' '}
          </LocalizationProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </StylesProvider>
  );
};

function withRoot<T>(Component: React.ComponentType<T>): React.ComponentType<T> {
  function WithRoot(props: T) {
    return (
      <ThemeProviders>
        {/* @ts-expect-error [EN-10263] - TS2322 - Type 'T' is not assignable to type 'IntrinsicAttributes & T'. */}
        <Component {...props} />
      </ThemeProviders>
    );
  }

  return WithRoot;
}

export default withRoot;
